import Component from '@Component';
import { breakpoints } from '@Constants';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 1,
  peek: 16,
  rewind: false,
  bound: true,
  gap: 16,
  breakpoints: {
    [breakpoints['break-2']]: {
      peek: 0,
      startAt: 0,
    },
  },
};

const selectors = {
  slideSelector: '[data-general-slider="slide"]',
  leftArrowSelector: '[data-general-slider="arrow-left"]',
  rightArrowSelector: '[data-general-slider="arrow-right"]',
  arrowsContainerSelector: '[data-general-slider="arrows"]',
  slideIndicatorSelector: '[data-general-slider="indicator"]',
  slideIndicatorActiveClass: 'nav-btn--active',
};

export default class SectionGeneralSlider extends Component {
  static selector = '[data-comp-general-slider]';
  constructor(containerEl) {
    super(containerEl);
    this.subNavSlider = new GlideSlider(
      containerEl,
      glideOptions,
      selectors,
    );

    this.subNavSliderGlideInstance = this.subNavSlider.getGlideSlider();

    if (this.subNavSlider.hasArrowButtons()) {
      this.subNavSliderGlideInstance.on(['mount.after', 'run.after'], () => {
        this.subNavSlider.handleArrowButtonVisibility();
      });
    }

    this.subNavSliderGlideInstance.mount();
  }
}
